import { FC } from 'react';

import { DownPayment } from '../../components/DownPayment';
import { useSelector } from 'react-redux';
import { selectCalculatorValues } from '../../selectors/selectCalculatorValues';
import { formatNumberWithSpaces, transformNumToString } from '../../../common/utils';

export const DownPaymentContainer: FC = () => {
  const {
    calculatedValues: { necessarySum, commissionByRate, initialPaymentSum },
    discountMortgagePercentBySeller,
    necessarySumInPercent,
  } = useSelector(selectCalculatorValues);

  return (
    <DownPayment
      requiredAmountCash={formatNumberWithSpaces(necessarySum)}
      downPayment={formatNumberWithSpaces(initialPaymentSum)}
      commission={formatNumberWithSpaces(commissionByRate)}
      discountPercentBySeller={transformNumToString(discountMortgagePercentBySeller)}
      necessarySumInPercent={necessarySumInPercent}
    />
  );
};
